<template>
  <span>{{inventory}}</span>
</template>
<script>
  export default {
    props: ['inventory']
  }
</script>
<style scoped>
  span {
    display: inline-block;
    margin: 0;
    padding: 0;
    font-size: 15px;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// index.vue?8ef5e954